import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { catchError, concatMap, map, mergeMap, tap, toArray } from 'rxjs/operators'
import { of } from 'rxjs'
import { ActionFailed } from '@tokeet-frontend/utility'
import { LosDiscountService } from './los-discount.service'
import { Toaster } from '@tokeet/tv3-platform'
import {
  AddLosDiscount,
  AddLosDiscountComplete,
  DeleteLosDiscount,
  DeleteLosDiscountComplete,
  DeleteMultipleLosDiscount,
  DeleteMultipleLosDiscountComplete,
  LoadLosDiscounts,
  LoadLosDiscountsComplete,
} from './los-discount.actions'

@Injectable()
export class LosDiscountEffects {
  @Effect()
  load$ = this.actions$.pipe(
    ofType(LoadLosDiscounts),
    mergeMap(() =>
      this.losDiscountService.load().pipe(
        map((items) => LoadLosDiscountsComplete({ items })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  add$ = this.actions$.pipe(
    ofType(AddLosDiscount),
    mergeMap(({ payload }) =>
      this.losDiscountService.create(payload).pipe(
        map((res) => AddLosDiscountComplete({ item: res })),
        tap(() => this.toaster.success($localize`LOS discount added successfully.`)),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  delete$ = this.actions$.pipe(
    ofType(DeleteLosDiscount),
    concatMap(({ id }) =>
      this.losDiscountService.delete(id).pipe(
        map((res) => DeleteLosDiscountComplete({ id })),
        tap(() => this.toaster.success($localize`LOS discount removed successfully.`)),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  deleteMultiple$ = this.actions$.pipe(
    ofType(DeleteMultipleLosDiscount),
    concatMap(({ ids }) =>
      of(...ids).pipe(
        concatMap((id) => this.losDiscountService.delete(id)),
        toArray(),
        map((res) => DeleteMultipleLosDiscountComplete({ ids })),
        tap(() => this.toaster.success($localize`LOS discounts removed successfully.`)),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(private actions$: Actions, private toaster: Toaster, private losDiscountService: LosDiscountService) {}
}
